'use client';

import { usePathname } from '@/i18n/routing';

const version = process.env.NEXT_PUBLIC_APP_VERSION ?? '0.0.0';

// Full-bleed, viewport-height workspaces hide the global footer so it doesn't
// force a scroll past the fold. `usePathname` (from next-intl routing) is
// locale-stripped, so match the un-prefixed path.
const HIDDEN_ON_ROUTES = [/^\/dashboard\/photo-scanning\/[^/]+$/];

export function AppVersion() {
  const pathname = usePathname();
  if (HIDDEN_ON_ROUTES.some((re) => re.test(pathname))) return null;

  return (
    <footer className='mt-auto border-t py-3 text-center'>
      <span className='text-muted-foreground/60 text-xs tracking-widest uppercase'>
        Safha Archive
      </span>
      <span className='text-muted-foreground/40 mx-1.5 text-xs'>·</span>
      <span className='text-muted-foreground/50 font-mono text-[11px]'>
        v{version}
      </span>
    </footer>
  );
}
